import React, { useState } from "react";
import SendIcon from "@mui/icons-material/Send";
import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from "@mui/icons-material/Print";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { restrict } from "../../../../../utils/restric/restrict";
import getDecryptedToken from "../../../../../api/getDecryptedToken";

function PaymentTr({ item, handlePrint, handleSms, handleEdit, handleDelete, editable }: any) {
  const [itemId, setitemId] = useState("");

  const permit = getDecryptedToken("role");
  const onclick = (item: any) => {
    if (restrict()) return;
    itemId !== item?._id && handleEdit(item);
  };

  return (
    <tr className="hover:bg-slate-50/50 transition-colors group">
      <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600">
        {item?.createdAt?.split("T")[0]}
      </td>
      <td className="px-4 py-3 whitespace-nowrap">
        <span className="text-sm font-bold text-indigo-600">#{item?.invoiceNo}</span>
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-sm font-bold text-slate-800 text-right">
        {parseInt(item?.netotal) + parseInt(item?.discount)}
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-sm font-semibold text-orange-600 text-right">
        {item?.discount}
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-sm font-semibold text-emerald-600 text-right">
        {item?.cash}
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-sm font-semibold text-indigo-600 text-right hidden lg:table-cell">
        {item?.card}
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-sm font-semibold text-sky-600 text-right hidden lg:table-cell">
        {item?.bankTransfer}
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-center">
        <div className="flex gap-1 justify-center">
          <button
            onClick={() => handlePrint({ paymentid: item?._id, invoiceno: item?.invoiceNo })}
            className="w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center hover:bg-indigo-100 active:bg-indigo-200 transition-all focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1"
            title="Print"
            aria-label="Print invoice"
          >
            <PrintIcon sx={{ fontSize: 18 }} />
          </button>
          <button
            onClick={() => itemId !== item?._id && handleSms(item)}
            className="w-8 h-8 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center hover:bg-emerald-100 active:bg-emerald-200 transition-all focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-1"
            title="Send SMS"
            aria-label="Send SMS"
          >
            <SendIcon sx={{ fontSize: 18 }} />
          </button>
          {editable && (
            <button
              onClick={() => onclick(item)}
              className="w-8 h-8 rounded-lg bg-amber-50 text-amber-600 flex items-center justify-center hover:bg-amber-100 active:bg-amber-200 transition-all focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-1"
              title="Edit"
              aria-label="Edit invoice"
            >
              <EditIcon sx={{ fontSize: 18 }} />
            </button>
          )}
          {editable &&permit === "Super Admin" && (
            <button
              onClick={() => handleDelete(item)}
              className="w-8 h-8 rounded-lg bg-red-50 text-red-600 flex items-center justify-center hover:bg-red-100 active:bg-red-200 transition-all focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-1"
              title="Delete"
              aria-label="Delete payment"
            >
              <DeleteOutlineIcon sx={{ fontSize: 18 }} />
            </button>
          )}
        </div>
      </td>
    </tr>
  );
}

export default PaymentTr;
